import Md5 from 'crypto-js/md5';
import { pickBy } from 'lodash';

/* 爆板sign */
/**
 * 去除对象中的 falsy 值
 */
export const removeFalsy = (
  obj: Record<string, unknown>,
  ...falsyValue: unknown[]
): Partial<Record<string, unknown>> => {
  const falsyList = [undefined, null, ...falsyValue];
  return pickBy(obj, (value) => !falsyList.includes(value));
};
/**
 * 移除对象中的File值
 * @param obj
 */
export const removeFileData = (obj: Record<string, unknown>): Record<string, unknown> => {
  if (Object.prototype.toString.call(obj) !== '[object Object]') {
    return obj;
  }
  return pickBy(obj, (value) => Object.prototype.toString.call(value) !== '[object File]');
};
/**
 * 对象值按 ascii 码排序
 * @param obj
 */
export const objSort = (obj: Record<string, unknown>): Record<string, unknown> => {
  const newObj: Record<string, unknown> = {};
  const keys = Object.keys(obj).sort();
  keys.forEach((key) => {
    newObj[key] = obj[key];
  });
  return newObj;
};
/**
 * 拼接对象
 * @param data
 */
export const splicingObject = (data: Record<string, unknown>): string => {
  const entries = Object.entries(data).map(([key, value]) => {
    let formattedValue = value;
    if (['Array', 'Object'].includes(Object.prototype.toString.call(value).slice(8, -1))) {
      formattedValue = JSON.stringify(value);
    } else if (typeof value === 'string') {
      formattedValue = value.trim();
    }
    return `${key}=${formattedValue as keyof typeof value}`;
  });
  return entries.join('&');
};
/**
 * 接口签名
 */
export const generateSign = (data: Record<string, unknown>): string => {
  const token = localStorage.getItem('baoban_supplier');
  const entityData = removeFalsy(data, '');
  const noFileEntityData = removeFileData(entityData);
  console.log('noFileEntityData', noFileEntityData);
  const sortData = objSort(noFileEntityData);
  const strData = splicingObject(sortData);
  console.log('strData', strData);
  // Java中读取换行符是\r\n，js中是\n，所以需要替换一下
  const formatStrData = strData.replace(/\r?\n/g, '\r\n');
  const signStr = `${formatStrData}&key=${token}`;
  return Md5(signStr).toString().toUpperCase();
};
/**
 * 生成 formData 数据
 */
export const generateFormData = (target: Record<string, string>): FormData => {
  const formData = new FormData();
  if (target) {
    Object.keys(target).forEach((key) => {
      if (['Array', 'Object'].includes(Object.prototype.toString.call(target[key]).slice(8, -1))) {
        formData.append(key, JSON.stringify(target[key]));
      } else {
        formData.append(key, target[key] as string | Blob); // Explicitly type target[key] as string | Blob
      }
    });
  }
  return formData;
};
/* 爆板sign */
